export default __webpack_public_path__ + "locales/es/Settings.json?hash=514bb9b23f99e20ec02ad686ed3c9838";